import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
var _UIManagerAny_getViewManagerConfig, _UIManagerAny_getConstants;
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Platform, UIManager, DeviceEventEmitter } from "react-native";
// @ts-ignore - it isn't typed by TS & don't have definitelyTyped types
import deepEqual from "lodash/isEqual";
import RNGestureHandlerModule from "../RNGestureHandlerModule";
import { State } from "../State";
import { handlerIDToTag, getNextHandlerTag, registerOldGestureHandler } from "./handlersRegistry";
import { filterConfig, findNodeHandle, scheduleFlushOperations } from "./gestureHandlerCommon";
import { isFabric, isJestEnv, tagMessage } from "../utils";
import { ActionType } from "../ActionType";
import { PressabilityDebugView } from "./PressabilityDebugView";
import GestureHandlerRootViewContext from "../GestureHandlerRootViewContext";
import { ghQueueMicrotask } from "../ghQueueMicrotask";
var UIManagerAny = UIManager;
var customGHEventsConfigFabricAndroid = {
    topOnGestureHandlerEvent: {
        registrationName: "onGestureHandlerEvent"
    },
    topOnGestureHandlerStateChange: {
        registrationName: "onGestureHandlerStateChange"
    }
};
var customGHEventsConfig = _object_spread({
    onGestureHandlerEvent: {
        registrationName: "onGestureHandlerEvent"
    },
    onGestureHandlerStateChange: {
        registrationName: "onGestureHandlerStateChange"
    }
}, isFabric() && Platform.OS === "android" && customGHEventsConfigFabricAndroid);
// Add gesture specific events to genericDirectEventTypes object exported from UIManager
// native module.
// Once new event types are registered with react it is possible to dispatch these
// events to all kind of native views.
UIManagerAny.genericDirectEventTypes = _object_spread({}, UIManagerAny.genericDirectEventTypes, customGHEventsConfig);
var _UIManagerAny_getViewManagerConfig1;
// In newer versions of RN the `genericDirectEventTypes` is located in the object
// returned by UIManager.getViewManagerConfig('getConstants') or in older RN UIManager.getConstants(), we need to add it there as well to make
// it compatible with RN 61+
var UIManagerConstants = (_UIManagerAny_getViewManagerConfig1 = (_UIManagerAny_getViewManagerConfig = UIManagerAny.getViewManagerConfig) === null || _UIManagerAny_getViewManagerConfig === void 0 ? void 0 : _UIManagerAny_getViewManagerConfig.call(UIManagerAny, "getConstants")) !== null && _UIManagerAny_getViewManagerConfig1 !== void 0 ? _UIManagerAny_getViewManagerConfig1 : (_UIManagerAny_getConstants = UIManagerAny.getConstants) === null || _UIManagerAny_getConstants === void 0 ? void 0 : _UIManagerAny_getConstants.call(UIManagerAny);
if (UIManagerConstants) {
    UIManagerConstants.genericDirectEventTypes = _object_spread({}, UIManagerConstants.genericDirectEventTypes, customGHEventsConfig);
}
// Wrap JS responder calls and notify gesture handler manager
var tmp = UIManagerAny.setJSResponder, oldSetJSResponder = tmp === void 0 ? function() {
//no operation
} : tmp, tmp1 = UIManagerAny.clearJSResponder, oldClearJSResponder = tmp1 === void 0 ? function() {
//no operation
} : tmp1;
UIManagerAny.setJSResponder = function(tag, blockNativeResponder) {
    RNGestureHandlerModule.handleSetJSResponder(tag, blockNativeResponder);
    oldSetJSResponder(tag, blockNativeResponder);
};
UIManagerAny.clearJSResponder = function() {
    RNGestureHandlerModule.handleClearJSResponder();
    oldClearJSResponder();
};
var allowTouches = true;
var DEV_ON_ANDROID = __DEV__ && Platform.OS === "android";
// Toggled inspector blocks touch events in order to allow inspecting on Android
// This needs to be a global variable in order to set initial state for `allowTouches` property in Handler component
if (DEV_ON_ANDROID) {
    DeviceEventEmitter.addListener("toggleElementInspector", function() {
        allowTouches = !allowTouches;
    });
}
function hasUnresolvedRefs(props) {
    // TODO(TS) - add type for extract arg
    var extract = function(refs) {
        if (!Array.isArray(refs)) {
            return refs && refs.current === null;
        }
        return refs.some(function(r) {
            return r && r.current === null;
        });
    };
    return extract(props["simultaneousHandlers"]) || extract(props["waitFor"]);
}
var _obj;
var stateToPropMappings = (_obj = {}, _define_property(_obj, State.UNDETERMINED, undefined), _define_property(_obj, State.BEGAN, "onBegan"), _define_property(_obj, State.FAILED, "onFailed"), _define_property(_obj, State.CANCELLED, "onCancelled"), _define_property(_obj, State.ACTIVE, "onActivated"), _define_property(_obj, State.END, "onEnded"), _obj);
var UNRESOLVED_REFS_RETRY_LIMIT = 1;
// TODO(TS) - make sure that BaseGestureHandlerProps doesn't need other generic parameter to work with custom properties.
export default function createHandler(param) {
    var name = param.name, _param_allowedProps = param.allowedProps, allowedProps = _param_allowedProps === void 0 ? [] : _param_allowedProps, _param_config = param.config, config = _param_config === void 0 ? {} : _param_config, transformProps = param.transformProps, _param_customNativeProps = param.customNativeProps, customNativeProps = _param_customNativeProps === void 0 ? [] : _param_customNativeProps;
    var _React_Component;
    var Handler = /*#__PURE__*/ function(_superClass) {
        "use strict";
        _inherits(Handler, _superClass);
        var _super = _create_super(Handler);
        function Handler(props) {
            _class_call_check(this, Handler);
            var _this;
            _this = _super.call(this, props);
            _define_property(_assert_this_initialized(_this), "handlerTag", void 0);
            _define_property(_assert_this_initialized(_this), "config", void 0);
            _define_property(_assert_this_initialized(_this), "propsRef", void 0);
            _define_property(_assert_this_initialized(_this), "isMountedRef", void 0);
            _define_property(_assert_this_initialized(_this), "viewNode", void 0);
            _define_property(_assert_this_initialized(_this), "viewTag", void 0);
            _define_property(_assert_this_initialized(_this), "inspectorToggleListener", void 0);
            _define_property(_assert_this_initialized(_this), "onGestureHandlerEvent", function(event) {
                if (event.nativeEvent.handlerTag === _this.handlerTag) {
                    if (typeof _this.props.onGestureEvent === "function") {
                        var _this_props_onGestureEvent, _this_props;
                        (_this_props_onGestureEvent = (_this_props = _this.props).onGestureEvent) === null || _this_props_onGestureEvent === void 0 ? void 0 : _this_props_onGestureEvent.call(_this_props, event);
                    }
                } else {
                    var _this_props_onGestureHandlerEvent, _this_props1;
                    (_this_props_onGestureHandlerEvent = (_this_props1 = _this.props).onGestureHandlerEvent) === null || _this_props_onGestureHandlerEvent === void 0 ? void 0 : _this_props_onGestureHandlerEvent.call(_this_props1, event);
                }
            });
            // TODO(TS) - make sure this is right type for event
            _define_property(_assert_this_initialized(_this), "onGestureHandlerStateChange", function(event) {
                if (event.nativeEvent.handlerTag === _this.handlerTag) {
                    if (typeof _this.props.onHandlerStateChange === "function") {
                        var _this_props_onHandlerStateChange, _this_props;
                        (_this_props_onHandlerStateChange = (_this_props = _this.props).onHandlerStateChange) === null || _this_props_onHandlerStateChange === void 0 ? void 0 : _this_props_onHandlerStateChange.call(_this_props, event);
                    }
                    var state = event.nativeEvent.state;
                    var stateEventName = stateToPropMappings[state];
                    var eventHandler = stateEventName && _this.props[stateEventName];
                    if (eventHandler && typeof eventHandler === "function") {
                        eventHandler(event);
                    }
                } else {
                    var _this_props_onGestureHandlerStateChange, _this_props1;
                    (_this_props_onGestureHandlerStateChange = (_this_props1 = _this.props).onGestureHandlerStateChange) === null || _this_props_onGestureHandlerStateChange === void 0 ? void 0 : _this_props_onGestureHandlerStateChange.call(_this_props1, event);
                }
            });
            _define_property(_assert_this_initialized(_this), "refHandler", function(node) {
                _this.viewNode = node;
                var child = React.Children.only(_this.props.children);
                // TODO(TS) fix ref type
                var ref = child.ref;
                if (ref !== null) {
                    if (typeof ref === "function") {
                        ref(node);
                    } else {
                        ref.current = node;
                    }
                }
            });
            _define_property(_assert_this_initialized(_this), "createGestureHandler", function(newConfig) {
                _this.config = newConfig;
                RNGestureHandlerModule.createGestureHandler(name, _this.handlerTag, newConfig);
            });
            _define_property(_assert_this_initialized(_this), "attachGestureHandler", function(newViewTag) {
                _this.viewTag = newViewTag;
                if (Platform.OS === "web") {
                    // typecast due to dynamic resolution, attachGestureHandler should have web version signature in this branch
                    RNGestureHandlerModule.attachGestureHandler(_this.handlerTag, newViewTag, ActionType.JS_FUNCTION_OLD_API, _this.propsRef);
                } else {
                    registerOldGestureHandler(_this.handlerTag, {
                        onGestureEvent: _this.onGestureHandlerEvent,
                        onGestureStateChange: _this.onGestureHandlerStateChange
                    });
                    var actionType = function() {
                        var _this_props, _this_props1, _this_props2;
                        if (((_this_props = _this.props) === null || _this_props === void 0 ? void 0 : _this_props.onGestureEvent) && "current" in _this.props.onGestureEvent || ((_this_props1 = _this.props) === null || _this_props1 === void 0 ? void 0 : _this_props1.onHandlerStateChange) && "current" in _this.props.onHandlerStateChange) {
                            // Reanimated worklet
                            return ActionType.REANIMATED_WORKLET;
                        } else if (((_this_props2 = _this.props) === null || _this_props2 === void 0 ? void 0 : _this_props2.onGestureEvent) && "__isNative" in _this.props.onGestureEvent) {
                            // Animated.event with useNativeDriver: true
                            return ActionType.NATIVE_ANIMATED_EVENT;
                        } else {
                            // JS callback or Animated.event with useNativeDriver: false
                            return ActionType.JS_FUNCTION_OLD_API;
                        }
                    }();
                    RNGestureHandlerModule.attachGestureHandler(_this.handlerTag, newViewTag, actionType);
                }
                scheduleFlushOperations();
            });
            _define_property(_assert_this_initialized(_this), "updateGestureHandler", function(newConfig) {
                _this.config = newConfig;
                RNGestureHandlerModule.updateGestureHandler(_this.handlerTag, newConfig);
                scheduleFlushOperations();
            });
            _this.handlerTag = getNextHandlerTag();
            _this.config = {};
            _this.propsRef = /*#__PURE__*/ React.createRef();
            _this.isMountedRef = /*#__PURE__*/ React.createRef();
            _this.state = {
                allowTouches: allowTouches
            };
            if (props.id) {
                if (handlerIDToTag[props.id] !== undefined) {
                    throw new Error('Handler with ID "'.concat(props.id, '" already registered'));
                }
                handlerIDToTag[props.id] = _this.handlerTag;
            }
            return _this;
        }
        _create_class(Handler, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this = this;
                    var props = this.props;
                    this.isMountedRef.current = true;
                    if (DEV_ON_ANDROID) {
                        this.inspectorToggleListener = DeviceEventEmitter.addListener("toggleElementInspector", function() {
                            _this.setState(function(_) {
                                return {
                                    allowTouches: allowTouches
                                };
                            });
                            _this.update(UNRESOLVED_REFS_RETRY_LIMIT);
                        });
                    }
                    if (hasUnresolvedRefs(props)) {
                        // If there are unresolved refs (e.g. ".current" has not yet been set)
                        // passed as `simultaneousHandlers` or `waitFor`, we enqueue a call to
                        // _update method that will try to update native handler props using
                        // queueMicrotask. This makes it so update() function gets called after all
                        // react components are mounted and we expect the missing ref object to
                        // be resolved by then.
                        ghQueueMicrotask(function() {
                            _this.update(UNRESOLVED_REFS_RETRY_LIMIT);
                        });
                    }
                    this.createGestureHandler(filterConfig(transformProps ? transformProps(this.props) : this.props, _to_consumable_array(allowedProps).concat(_to_consumable_array(customNativeProps)), config));
                    this.attachGestureHandler(findNodeHandle(this.viewNode)); // TODO(TS) - check if this can be null
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var viewTag = findNodeHandle(this.viewNode);
                    if (this.viewTag !== viewTag) {
                        this.attachGestureHandler(viewTag); // TODO(TS) - check interaction between _viewTag & findNodeHandle
                    }
                    this.update(UNRESOLVED_REFS_RETRY_LIMIT);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this_inspectorToggleListener;
                    (_this_inspectorToggleListener = this.inspectorToggleListener) === null || _this_inspectorToggleListener === void 0 ? void 0 : _this_inspectorToggleListener.remove();
                    this.isMountedRef.current = false;
                    RNGestureHandlerModule.dropGestureHandler(this.handlerTag);
                    scheduleFlushOperations();
                    // We can't use this.props.id directly due to TS generic type narrowing bug, see https://github.com/microsoft/TypeScript/issues/13995 for more context
                    var handlerID = this.props.id;
                    if (handlerID) {
                        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete handlerIDToTag[handlerID];
                    }
                }
            },
            {
                key: "update",
                value: function update(remainingTries) {
                    var _this = this;
                    if (!this.isMountedRef.current) {
                        return;
                    }
                    var props = this.props;
                    // When ref is set via a function i.e. `ref={(r) => refObject.current = r}` instead of
                    // `ref={refObject}` it's possible that it won't be resolved in time. Seems like trying
                    // again is easy enough fix.
                    if (hasUnresolvedRefs(props) && remainingTries > 0) {
                        ghQueueMicrotask(function() {
                            _this.update(remainingTries - 1);
                        });
                    } else {
                        var newConfig = filterConfig(transformProps ? transformProps(this.props) : this.props, _to_consumable_array(allowedProps).concat(_to_consumable_array(customNativeProps)), config);
                        if (!deepEqual(this.config, newConfig)) {
                            this.updateGestureHandler(newConfig);
                        }
                    }
                }
            },
            {
                key: "setNativeProps",
                value: function setNativeProps(updates) {
                    var mergedProps = _object_spread({}, this.props, updates);
                    var newConfig = filterConfig(transformProps ? transformProps(mergedProps) : mergedProps, _to_consumable_array(allowedProps).concat(_to_consumable_array(customNativeProps)), config);
                    this.updateGestureHandler(newConfig);
                }
            },
            {
                key: "render",
                value: function render() {
                    if (__DEV__ && !this.context && !isJestEnv() && Platform.OS !== "web") {
                        throw new Error(name + " must be used as a descendant of GestureHandlerRootView. Otherwise the gestures will not be recognized. See https://docs.swmansion.com/react-native-gesture-handler/docs/installation for more details.");
                    }
                    var gestureEventHandler = this.onGestureHandlerEvent;
                    var _this_props = this.props, onGestureEvent = _this_props.onGestureEvent, onGestureHandlerEvent = _this_props.onGestureHandlerEvent;
                    if (onGestureEvent && typeof onGestureEvent !== "function") {
                        // If it's not a method it should be an native Animated.event
                        // object. We set it directly as the handler for the view
                        // In this case nested handlers are not going to be supported
                        if (onGestureHandlerEvent) {
                            throw new Error("Nesting touch handlers with native animated driver is not supported yet");
                        }
                        gestureEventHandler = onGestureEvent;
                    } else {
                        if (onGestureHandlerEvent && typeof onGestureHandlerEvent !== "function") {
                            throw new Error("Nesting touch handlers with native animated driver is not supported yet");
                        }
                    }
                    var gestureStateEventHandler = this.onGestureHandlerStateChange;
                    var _this_props1 = this.props, onHandlerStateChange = _this_props1.onHandlerStateChange, onGestureHandlerStateChange = _this_props1.onGestureHandlerStateChange;
                    if (onHandlerStateChange && typeof onHandlerStateChange !== "function") {
                        // If it's not a method it should be an native Animated.event
                        // object. We set it directly as the handler for the view
                        // In this case nested handlers are not going to be supported
                        if (onGestureHandlerStateChange) {
                            throw new Error("Nesting touch handlers with native animated driver is not supported yet");
                        }
                        gestureStateEventHandler = onHandlerStateChange;
                    } else {
                        if (onGestureHandlerStateChange && typeof onGestureHandlerStateChange !== "function") {
                            throw new Error("Nesting touch handlers with native animated driver is not supported yet");
                        }
                    }
                    var events = {
                        onGestureHandlerEvent: this.state.allowTouches ? gestureEventHandler : undefined,
                        onGestureHandlerStateChange: this.state.allowTouches ? gestureStateEventHandler : undefined
                    };
                    this.propsRef.current = events;
                    var child = null;
                    try {
                        child = React.Children.only(this.props.children);
                    } catch (e) {
                        throw new Error(tagMessage("".concat(name, " got more than one view as a child. If you want the gesture to work on multiple views, wrap them with a common parent and attach the gesture to that view.")));
                    }
                    var grandChildren = child.props.children;
                    if (__DEV__ && child.type && (child.type === "RNGestureHandlerButton" || child.type.name === "View" || child.type.displayName === "View")) {
                        grandChildren = React.Children.toArray(grandChildren);
                        grandChildren.push(/*#__PURE__*/ _jsx(PressabilityDebugView, {
                            color: "mediumspringgreen",
                            hitSlop: child.props.hitSlop
                        }, "pressabilityDebugView"));
                    }
                    var _this_props_testID;
                    return /*#__PURE__*/ React.cloneElement(child, _object_spread(_object_spread_props(_object_spread({
                        ref: this.refHandler,
                        collapsable: false
                    }, isJestEnv() ? {
                        handlerType: name,
                        handlerTag: this.handlerTag
                    } : {}), {
                        testID: (_this_props_testID = this.props.testID) !== null && _this_props_testID !== void 0 ? _this_props_testID : child.props.testID
                    }), events), grandChildren);
                }
            }
        ]);
        return Handler;
    }(_React_Component = React.Component);
    _define_property(Handler, "displayName", name);
    _define_property(Handler, "contextType", GestureHandlerRootViewContext);
    return Handler;
}
